import { useField } from "formik";

const MmcTextInput = ({ label, ...props }) => {
  const [field, meta] = useField({ ...props });

  return (
    <>
      <div className="w3-row w3-padding-small">
        <div className="w3-third ">
          <label htmlFor={props.name}>{label}:</label>
        </div>
        <div className="w3-twothird">
          <input
            {...props}
            {...field}
            className="w3-input w3-border w3-round form-input"
          />
        </div>
      </div>
      {meta.touched && meta.error && (
        <div className="w3-row w3-center">
          <label className="error-label">{meta.error}</label>
        </div>
      )}
    </>
  );
};

export default MmcTextInput;
